import { Translation } from '@ps/web-shared-components';
import React, { memo } from 'react';

import useBetslipHasItemWithoutOdds from '../../../../hooks/useBetslipHasItemWithoutOdds';
import useDisplayPriceChanges from '../../../../hooks/useDisplayPriceChanges';
import useTotals from '../../../../hooks/useTotals';

import { TotalRow } from './TotalRow/TotalRow';
import {
  TXTWCL_Bonus_Cash,
  TXTWCL_Free_Bet,
  TXTWCL_Total_Potential_Returns,
  TXTWCL_Total_Stake,
  TXTWCL_n_a
} from './Totals.messages.json';
import styles from './Totals.scss';

const Totals: React.FC = () => {
  const { totalStake, totalPotentialReturns, bonusCashStake, freeBetsStake } = useTotals();
  const betslipHasItemWithoutOdds = useBetslipHasItemWithoutOdds();
  const { displayFooterPriceChanges } = useDisplayPriceChanges();

  return (
    <ul className={styles.returns}>
      <TotalRow name="stake" translationTag={TXTWCL_Total_Stake} value={totalStake} />

      {!!bonusCashStake && (
        <TotalRow
          name="bonus-cash-total"
          className={styles.promotion}
          translationTag={TXTWCL_Bonus_Cash}
          value={bonusCashStake}
          dollarValue
        />
      )}

      {!!freeBetsStake && (
        <TotalRow
          name="free-bet-total"
          className={styles.promotion}
          translationTag={TXTWCL_Free_Bet}
          value={freeBetsStake}
          dollarValue
        />
      )}

      <TotalRow
        name="potential-returns"
        className={
          displayFooterPriceChanges ? styles.potentialReturnsPriceChange : styles.potentialReturns
        }
        translationTag={TXTWCL_Total_Potential_Returns}
        value={betslipHasItemWithoutOdds ? <Translation {...TXTWCL_n_a} /> : totalPotentialReturns}
      />
    </ul>
  );
};

export default memo(Totals);
